import React, {useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import close_icon from '../assets/images/icons/close-icon.png'
import tick_icon from '../assets/images/icons/tick-icon.png'




import ModelInput from './inputText/modelInput';
import SubmitButton from './loadingButton/modelSubmitButton';
import CancelButton from './loadingButton/modelCancelButton';




function SuccessfulModel(props) {
  
    return (
      <> 
        <Modal 
          show={props.show} 
          onHide={props.hide}
          centered
          size="lg">
          <div className="model-body">
            <div className="d-flex model-title" style={{padding: 20}}></div>
            <div className="success-model-body-content">
              <img src={tick_icon}/>
              <span className="thank-you-text">Thank You</span>
              <div className="mb-4 mt-4">
                <span className="thank-you-description">A You have registered Successfully</span>
              </div>
              <Button
                onClick={()=>props.hide()} 
                className="model-accept-button"
                variant="light"
                style={{
                  border: '2px solid #979797'
                }}>
                  <span>
                      OK
                  </span>
              </Button>
            </div>
          </div>
   
        </Modal>
      </>
    );
  }
  
export default SuccessfulModel